import UrlTypeIcon from '@components/UrlTypeIcon/UrlTypeIcon';
import {
  faBalanceScale,
  faBookmark,
  faBrowser,
  faBuilding,
  faCamera,
  faEnvelope,
  faFax,
  faGiftCard,
  faHeading,
  faLeaf,
  faMapMarkerAlt,
  faPhone,
  faUser,
  faUserAstronaut,
  faUsers,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { CardMultiFieldType, CardUrl } from 'types';

export type IconType =
  | 'name'
  | 'department'
  | 'org_name'
  | 'job_title'
  | 'headline'
  | 'accreditations'
  | 'phone'
  | 'email'
  | 'address'
  | 'fax'
  | 'website'
  | 'environmental-footer'
  | 'banner'
  | 'legal-disclaimer'
  | 'profile-picture'
  | 'company-logo'
  | 'other'
  | CardUrl['type']
  | Exclude<CardMultiFieldType, 'url'>;

interface IconProps {
  className?: string;
  type: IconType;
}

const Icon: React.FC<React.PropsWithChildren<IconProps>> = ({ type, className }) => {
  if (type === 'name') {
    return <FontAwesomeIcon icon={faUser} className={className} />;
  } else if (type === 'department') {
    return <FontAwesomeIcon icon={faUsers} className={className} />;
  } else if (type === 'org_name') {
    return <FontAwesomeIcon icon={faBuilding} className={className} />;
  } else if (type === 'job_title') {
    return <FontAwesomeIcon icon={faUserAstronaut} className={className} />;
  } else if (type === 'accreditations') {
    return <FontAwesomeIcon icon={faGiftCard} className={className} />;
  } else if (type === 'headline') {
    return <FontAwesomeIcon icon={faHeading} className={className} />;
  } else if (type === 'phone') {
    return <FontAwesomeIcon icon={faPhone} className={className} />;
  } else if (type === 'email') {
    return <FontAwesomeIcon icon={faEnvelope} className={className} />;
  } else if (type === 'address') {
    return <FontAwesomeIcon icon={faMapMarkerAlt} className={className} />;
  } else if (type === 'fax') {
    return <FontAwesomeIcon icon={faFax} />;
  } else if (type === 'website') {
    return <FontAwesomeIcon icon={faBrowser} />;
  } else if (type === 'environmental-footer') {
    return <FontAwesomeIcon icon={faLeaf} />;
  } else if (type === 'banner') {
    return <FontAwesomeIcon icon={faBookmark} />;
  } else if (type === 'legal-disclaimer') {
    return <FontAwesomeIcon icon={faBalanceScale} />;
  } else if (type === 'profile-picture') {
    return <FontAwesomeIcon icon={faUser} />;
  } else if (type === 'company-logo') {
    return <FontAwesomeIcon icon={faBuilding} />;
  } else if (type === 'other') {
    return <FontAwesomeIcon icon={faCamera} />;
  } else {
    return <UrlTypeIcon type={type} />;
  }
};

export default Icon;
